import { Flex } from '../../../ui/layout/Flex';
import { Typography } from '../../../ui/typography/Typography';
import { useTranslation } from '../../../utils/useTranslation';

export const AdvertisingCatalogEmpty: React.FC<{}> = () => {
    const t = useTranslation();

    return (
        <Flex width="100%" height="100%" justifyContent="center" spacing={1}>
            <Typography variant="title1" weight="heavy">
                {t('Ничего не найдено')}
            </Typography>
            <Typography variant="body">{t('Попробуйте изменить поисковый запрос')}</Typography>
        </Flex>
    );
};
